export enum MenuItem {
  Export = "export",
  Offers = "offers",
  BulkVerify = "bulk-verify",
  BulkStatusUpdate = "bulk-status",
  BulkStatusDescriptionUpdate = "bulk-status-description",
  Tag = "tag",
  BulkSetVisibility = "bulk-set-visibility",
}
